import {EventEmitter} from 'events'

const $allowedActions = Symbol('allowedActions')

export default class RestrictedEventEmitter extends EventEmitter {
  constructor (options = {}) {
    super()
    this.name = options.name
    this.allowedActions = options.allowedActions
    this.logActions = options.logActions
  }

  emit (...args) {
    if (!this.allowedActions.has(args[0])) {
      const [eventName, ...eventArgs] = args
      throw new Error(`Action not allowed on RestrictedEventEmitter. '${eventName}' : ${eventArgs.join(', ')}`)
    }
    if (this.logActions) {
      console.log("Action fired.", this.name, args)
    }
    super.emit(...args)
  }

  on (eventName, func) {
    if (!this.allowedActions.has(eventName)) {
      throw new Error(`Action not allowed on RestrictedEventEmitter. '${eventName}'`)
    }
    super.on(eventName, func)
  }

  set allowedActions (actions) {
    if (actions instanceof Set) {
      this[$allowedActions] = actions
    } else if (Array.isArray(actions)) {
      this[$allowedActions] = new Set(actions)
    } else {
      throw new Error("allowedActions must be a Set or Array")
    }
  }

  get allowedActions () {
    return this[$allowedActions]
  }
}

RestrictedEventEmitter.prototype.addListener = RestrictedEventEmitter.prototype.on
